// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__30WGN","large":"styles_large__12RKK"};